import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useToast } from "@/lib/toast";

export default function Register() {
  const { register } = useAuth();
  const { toast } = useToast();
  const nav = useNavigate();
  const [form, setForm] = useState({ full_name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register({ ...form, role: "member" });
      toast("Account created", "success");
      nav("/");
    } catch (err) {
      toast(err?.response?.data?.detail || "Registration failed", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-6"
      style={{
        background:
          "linear-gradient(135deg, #0a4d29 0%, #0e6939 60%, #128043 100%)",
      }}
    >
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2.5 mb-5 justify-center">
          <img src="/brand/logo-transparent.png" alt="Jero-One" className="w-11 h-11 object-contain" />
          <div>
            <div className="text-white font-bold">Jero-One</div>
            <div className="text-white/70 text-[10px] uppercase tracking-wider">
              Workspace
            </div>
          </div>
        </div>

        <div className="card card-padded">
          <h1 className="h1 mb-1">Create account</h1>
          <p className="muted text-sm mb-5">Get started in less than a minute</p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="label">Full name</label>
              <input
                data-testid="reg-name"
                className="input"
                value={form.full_name}
                onChange={(e) => setForm({ ...form, full_name: e.target.value })}
              />
            </div>
            <div>
              <label className="label">Email</label>
              <input
                data-testid="reg-email"
                type="email"
                required
                className="input"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
              />
            </div>
            <div>
              <label className="label">Password</label>
              <input
                data-testid="reg-password"
                type="password"
                required
                minLength={6}
                className="input"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
              />
            </div>
            <button
              data-testid="reg-submit"
              type="submit"
              disabled={loading}
              className="btn btn-primary btn-lg w-full justify-center"
            >
              {loading ? "Creating…" : "Create account"}
            </button>
          </form>

          <div className="text-center text-xs muted mt-5">
            Already have an account?{" "}
            <Link
              to="/login"
              data-testid="goto-login"
              className="font-semibold"
              style={{ color: "var(--green-700)" }}
            >
              Sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
